import type { ComponentProps, PropsWithChildren } from 'react'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useLocalizedConfigLabels } from 'hooks/useLocalizedConfigLabels'
import FooterList from './FooterList'
import FooterListItem from './FooterListItem'

type InheritedFooterListProps = Pick<ComponentProps<typeof FooterList>, 'title'>

interface Props extends InheritedFooterListProps, PropsWithChildren {
  title: string
  items: Array<App.PageConfig>
}

function FooterItemList({ title, items, children }: Props) {
  const intl = useIntl()
  const configLabels = useMemo(
    () => items.flatMap(item => typeof item.text === 'string' ? [item.text] : []),
    [items],
  )
  const resolveConfigLabel = useLocalizedConfigLabels(configLabels)

  const localizedLinkText = (raw: string) => resolveConfigLabel(raw) ?? ''

  return <FooterList title={title}>
    {items.map((item) => {
      const text = typeof item.text === 'string'
        ? localizedLinkText(item.text)
        : intl.formatMessage(item.text)
      return <FooterListItem
        key={item.type}
        title={text}
        to={item.url?.to}
        href={item.url?.href}
      />
    })}
    {children}
  </FooterList>
}

export default FooterItemList
